<template>
  <div>
    <div class="row">
      <loading
        loader="dots"
        :height="170"
        :width="170"
        color="#3282b8"
        background-color="#505273"
        transition="fade"
        :active="isLoading"
        :is-full-page="true"
      ></loading>
      <div class="col-lg-12">
        <div class="row">
          <div class="col">
            <h4>
              Select Customer:
              <el-select
                class="select-info tab select-width"
                placeholder="Single Select"
                v-model="selects.selectCustomer"
                @change="filterCustomer()"
              >
                <el-option
                  v-for="option in selects.customers"
                  class="select-info"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </h4>
          </div>
          <div class="col">
            <h4>
              Select Region:
              <el-select
                class="select-info tab select-width"
                placeholder="Single Select"
                v-model="selects.selectRegion"
                @change="filterRegion()"
                :disabled="disableRegion"
              >
                <el-option
                  v-for="option in selects.regions"
                  class="select-info"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </h4>
          </div>
          <div class="col">
            <h4>
              Select Route:
              <el-select
                class="select-info tab select-width"
                placeholder="Single Select"
                v-model="selects.selectRoute"
                @change="filterRoute()"
                :disabled="disableRoute"
              >
                <el-option
                  v-for="option in selects.routes"
                  class="select-info"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </h4>
          </div>
          <div class="col text-center inline">
            <h4>
              {{ switchView() }}
              <base-switch
                class="bottom"
                v-model="switches.defaultOn"
              ></base-switch>
            </h4>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-4">
            <div class="row">
              <!-- Pie Chart -->
              <div class="col-lg-6 d-flex">
                <card class="card-chart card-chart-pie">
                  <template slot="header">
                    <h4 class="card-title">
                      <i class="tim-icons icon-chart-pie-36 text-info"></i>
                      <b>Status Ratio</b>
                    </h4>
                  </template>

                  <div class="chart-area">
                    <pie-chart
                      v-if="statusRatio.loaded"
                      :chart-data="statusRatio.chartData"
                      :extra-options="statusRatio.extraOptions"
                      :height="150"
                    ></pie-chart>
                    <div
                      class="d-flex justify-content-center spinner"
                      v-if="!statusRatio.loaded"
                    >
                      <circle-8></circle-8>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-lg-6 d-flex">
                <card>
                  <h4 class="card-title">Pickup Ratio</h4>
                  <base-progress
                    label="Total Pickup"
                    :value="tpPercentage"
                    value-position="right"
                    type="white"
                  />
                  <base-progress
                    label="Collected"
                    :value="cPercentage"
                    value-position="right"
                    type="blue"
                  />
                  <base-progress
                    label="Not Collected"
                    :value="ncPercentage"
                    value-position="right"
                    type="red"
                  />
                </card>
              </div>

              <!-- Bar Chart -->
              <div class="col d-flex">
                <card class="card-chart">
                  <template slot="header">
                    <h5 class="card-category">
                      <b>Up to date</b>
                    </h5>
                    <h4 class="card-title">
                      <i class="tim-icons icon-chart-bar-32 text-info"></i>
                      <b>Customer Rating</b>
                    </h4>
                  </template>
                  <div class="chart-area">
                    <bar-chart
                      v-if="customerRating.loaded"
                      :chart-data="customerRating.chartData"
                      :extra-options="customerRating.extraOptions"
                      :gradient-colors="customerRating.gradientColors"
                      :gradient-stops="customerRating.gradientStops"
                      :height="220"
                    ></bar-chart>
                    <div
                      class="d-flex justify-content-center spinner"
                      v-if="!customerRating.loaded"
                    >
                      <circle-8></circle-8>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="row">
              <div
                class="col-lg-3"
                v-for="card in statsCards_2"
                :key="card.footer"
              >
                <stats-card
                  :title="card.title"
                  :icon="card.icon"
                  imgStyle="width: 45px"
                >
                  <div slot="footer" v-html="card.footer"></div>
                </stats-card>
              </div>
              <div
                class="col-lg-12"
                style="height: 500px"
                v-if="!switches.defaultOn"
              >
                <!-- map -->
                <card type="plain" style="height: 85%">
                  <h3 class="card-title">
                    <div id="regularMap" class="map">
                      <l-map
                        ref="map"
                        id="toto"
                        :bounds="bounds"
                        :zoom="zoom"
                        :center="center"
                        :options="{ scrollWheelZoom: false }"
                        class="sidebar-map"
                        style="height: 95%"
                      >
                        <l-tile-layer
                          :url="url"
                          :attribution="attribution"
                        ></l-tile-layer>
                        <l-marker
                          v-for="(marker, index) in markers"
                          :icon="markerIcon(marker.status)"
                          :lat-lng="marker.location"
                          :key="marker.addMarker"
                          @click="selectPickup(index)"
                          ref="markersRef"
                        >
                          <l-tooltip :content="marker.pointName" />
                        </l-marker>
                        <modal type="mini" :show.sync="complaintModal">
                          <div class="row">
                            <div class="col-lg-12 text-center list-color">
                              <h4
                                style="
                                  color: white;
                                  background-color: #003975;
                                  font-weight: 600;
                                "
                              >
                                Today's Complain
                              </h4>
                              <ul v-if="!noComplain" class="list-unstyled">
                                <li
                                  v-for="complaint in selectComplain"
                                  :key="complaint"
                                >
                                  {{ complaint }}
                                </li>
                              </ul>
                              <h2 style="color: black" v-if="noComplain">
                                NO COMPLAIN FOR TODAY
                              </h2>
                            </div>
                          </div>
                        </modal>
                      </l-map>
                    </div>
                  </h3>
                </card>
              </div>
              <div
                class="col-md-12"
                v-if="switches.defaultOn"
                style="margin-top: 2%"
              >
                <card card-body-classes="table-full-width">
                  <el-table
                    :data="driverData"
                    height="435"
                    :header-cell-style="{
                      background: 'transparent',
                      border: 'none',
                      borderBottom: '0.5px solid #3d3f51',
                    }"
                    :cell-style="{
                      border: 'none',
                      borderBottom: '0.5px solid #3d3f51',
                    }"
                  >
                    <el-table-column
                      v-if="false"
                      property="id"
                    ></el-table-column>
                    <el-table-column
                      min-width="120"
                      sortable
                      align="center"
                      label="Point Name"
                      property="pointName"
                    ></el-table-column>
                    <el-table-column
                      min-width="120"
                      sortable
                      align="center"
                      label="Route Name"
                      property="routeName"
                    ></el-table-column>
                    <el-table-column
                      min-width="120"
                      sortable
                      align="center"
                      label="Driver Name"
                      property="driverName"
                    ></el-table-column>
                    <el-table-column
                      min-width="100"
                      sortable
                      align="center"
                      label="Last Pickup"
                      property="lastPickup"
                    ></el-table-column>
                    <el-table-column
                      min-width="60"
                      label="Picture"
                      align="center"
                    >
                      <div class="photo" slot-scope="{ row }">
                        <input
                          @click="row.modal = true"
                          type="image"
                          :src="row.picture"
                          width="90%"
                          height="90%"
                        />
                        <modal :show.sync="row.modal">
                          <div class="row">
                            <div class="col-lg-12 text-center">
                              <img :src="row.real" />
                            </div>
                          </div>
                        </modal>
                      </div>
                    </el-table-column>
                    <el-table-column
                      min-width="60"
                      label="Status"
                      align="center"
                    >
                      <div class="photo" slot-scope="{ row }">
                        <img :src="row.status" />
                      </div>
                    </el-table-column>
                  </el-table>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- List Table -->
      <div class="col-lg-4 d-flex">
        <card card-body-classes="table-full-width">
          <el-table
            :data="tableData"
            height="260"
            :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            <el-table-column
              min-width="105"
              label="Customer"
              property="custname"
            ></el-table-column>
            <el-table-column
              min-width="120"
              label="Total Collection"
              property="totalpickup"
            ></el-table-column>
            <el-table-column
              min-width="110"
              label="Collected"
              property="collected"
            ></el-table-column>
            <el-table-column
              min-width="130"
              label="Not Collected"
              property="notcollected"
            ></el-table-column>
          </el-table>
        </card>
      </div>

      <!-- Line Chart -->
      <div class="col-lg-8">
        <card class="card-chart" no-footer-line>
          <template slot="header">
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>
              <b>Overall Collection Graph</b>
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              v-if="collectionGraph.loaded"
              :chart-data="collectionGraph.chartData"
              :gradient-colors="collectionGraph.gradientColors"
              :gradient-stops="collectionGraph.gradientStops"
              :extra-options="collectionGraph.extraOptions"
              :height="200"
            ></line-chart>
            <div
              class="d-flex justify-content-center spinner"
              v-if="!collectionGraph.loaded"
            >
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { TabPane, Tabs, BaseProgress, Modal, BaseSwitch } from "src/components";
import { Table, TableColumn } from "element-ui";
import StatsCard from "src/components/Cards/StatsCard";
import { Select, Option } from "element-ui";
// import io from "socket.io-client";
import PieChart from "src/components/Charts/PieChart";
import LineChart from "src/components/Charts/LineChart";
import BarChart from "src/components/Charts/BarChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControlSidebar,
  LTooltip,
} from "vue2-leaflet";
import { latLngBounds, latLng } from "leaflet";
import { map } from "d3";
import moment from "moment";

export default {
  components: {
    Loading,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    TabPane,
    Tabs,
    StatsCard,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    Modal,
    PieChart,
    BarChart,
    LineChart,
    BaseProgress,
    BaseSwitch,
    Circle8,
  },
  data() {
    return {
      modals: {},
      complaintModal: false,
      selectComplain: [],
      noComplain: false,
      switches: {
        defaultOn: false,
      },
      // Line Chart
      collectionGraph: {
        chartData: {
          labels: [
            "7AM",
            "8AM",
            "9AM",
            "10AM",
            "11AM",
            "12PM",
            "1PM",
            "2PM",
            "3PM",
            "4PM",
            "5PM",
            "6PM",
            "7PM",
            "8PM",
            "9PM",
            "10PM",
            "11PM",
            "12AM",
          ],
          datasets: [
            {
              label: "Collected",
              fill: true,
              borderColor: "rgba(50, 130, 184, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(50, 130, 184, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [
                0, 20, 45, 60, 65, 80, 90, 100, 110, 120, 130, 140, 150, 160,
                162, 165, 185, 200,
              ],
            },
            {
              label: "Not Collected",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 3, 2, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [
                200, 185, 165, 162, 160, 150, 140, 130, 120, 110, 100, 90, 80,
                65, 60, 45, 20, 0,
              ],
            },
            {
              label: "Total Collection",
              fill: true,
              borderColor: "rgba(255, 255, 255, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 255, 255, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [
                200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200,
                200, 200, 200, 200, 200,
              ],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(50, 130, 184, 0.5)",
          "rgba(50, 130, 184, 0.0)",
          "rgba(50, 130, 184, 0.0)",
          "rgba(255, 3, 2, 0.5)",
          "rgba(255, 3, 2, 0)",
          "rgba(255, 3, 2, 0)",
          "rgba(255, 255, 255, 0.5)",
          "rgba(255, 255, 255, 0.0)",
          "rgba(255, 255, 255, 0.0)",
        ],
        gradientStops: [1, 0.4, 0, 1, 0.4, 0, 1, 0.4, 0],
      },
      // Bar Chart
      customerRating: {
        chartData: {
          labels: ["1 Star", "2 Star", "3 Star", "4 Star", "5 Star"],
          datasets: [
            {
              label: "Rating",
              fill: true,
              borderColor: "rgb(50, 130, 184, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [0, 0, 0, 0, 0],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: [
          "rgba(50, 130, 184, 0.8)",
          "rgba(50, 130, 184, 0.2)",
          "rgba(50, 130, 184, 0.0)",
        ],
        gradientStops: [1, 0],
      },
      // Attributes for map
      zoom: 14,
      center: L.latLng(2.747924, 101.7142),
      bounds: [[2.747924, 101.7142]],
      // url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      // markers: [],
      // Pie Chart
      statusRatio: {
        chartData: {
          labels: ["Total Pickup", "Not Collected", "Collected"],
          datasets: [],
        },
        loaded: false,
        extraOptions: chartConfigs.pieChartOptions,
      },
      tableData: [],
      statsCards_2: [
        {
          title: "0",
          icon: require("@/assets/img/total_pickup.png"),
          footer: "Total Pickup Point",
        },
        {
          title: "0",
          icon: require("@/assets/img/collected_trash.png"),
          footer: "Pickup Point Collected",
        },
        {
          title: "0",
          icon: require("@/assets/img/not_collected_trash.png"),
          footer: "Pickup Point Not Collected",
        },
        {
          title: "0",
          icon: require("@/assets/img/driver-icon.png"),
          footer: "Active Driver",
        },
      ],
      disableRegion: true,
      disableRoute: true,
      selects: {
        selectCustomer: "",
        selectRegion: "",
        selectRoute: "",
        customers: [{ value: "*", label: "All" }],
        regions: [{ value: "*", label: "All" }],
        routes: [{ value: "*", label: "All" }],
      },
      tpPercentage: 100,
      cPercentage: 0,
      ncPercentage: 0,
      socket: null,
      custData: [],
      mapData: [],
      regionData: null,
      routeData: null,
      ratingData: null,
      graphData: null,
      totalPickup: null,
      graphCounter: 0,
      isLoading: true,
      graphLabel: [
        "12AM",
        "1AM",
        "2AM",
        "3AM",
        "4AM",
        "5AM",
        "6AM",
        "7AM",
        "8AM",
        "9AM",
        "10AM",
        "11AM",
        "12PM",
        "1PM",
        "2PM",
        "3PM",
        "4PM",
        "5PM",
        "6PM",
        "7PM",
        "8PM",
        "9PM",
        "10PM",
        "11PM",
      ],
    };
  },

  created() {
    this.selects.selectCustomer = this.selects.customers[0].value;
    this.selects.selectRegion = this.selects.regions[0].value;
    this.selects.selectRoute = this.selects.routes[0].value;

    this.getSocketData();

    //temp worker
  },
  beforeDestroy() {
    console.log("SOCKS_CLOSED");
    this.socket.close();
  },
  mounted() {},

  computed: {
    markers: {
      get: function () {
        let newMarker = [];
        for (let i = 0; i < this.mapData.length; i++) {
          let time = this.mapData[i].CreatedAt[0];
          let lastPickup = time == "0" ? "-" : moment(time).format("LT");
          let picture = `https://afes.vectolabs.com:9991/images/${this.mapData[i].ColImgPath[0]}`;
          let load = {
            location: L.latLng(this.mapData[i].lat, this.mapData[i].long),
            pointName: `<h4 class='text-center' style="color: black">${this.mapData[i].pickupname}</h4> <img src='${picture}' > <br/><br/> Last pickup: ${lastPickup}`,
            status: this.mapData[i].status,
          };
          newMarker.push(load);
        }

        return newMarker;
      },
    },
  },

  methods: {
    selectPickup(index) {
      this.noComplain = false;
      this.complaintModal = true;
      if (this.mapData[index].Complain == null) {
        this.noComplain = true;
      } else {
        this.selectComplain = this.mapData[index].Complain;
      }
    },
    filterCustomer() {
      this.socket.close();
      this.collectionGraph.loaded = false;
      this.statusRatio.loaded = false;
      this.customerRating.loaded = false;
      this.disableRegion = true;
      this.disableRoute = true;
      this.selects.selectRegion = "*";
      this.selects.selectRoute = "*";
      this.getSocketData();
    },
    filterRegion() {
      this.socket.close();
      this.collectionGraph.loaded = false;
      this.statusRatio.loaded = false;
      this.customerRating.loaded = false;
      this.disableRoute = true;
      this.selects.selectRoute = "*";
      this.getSocketData();
    },
    filterRoute() {
      this.socket.close();
      this.collectionGraph.loaded = false;
      this.statusRatio.loaded = false;
      this.customerRating.loaded = false;
      this.getSocketData();
    },
    getSocketData() {
      this.socket = new WebSocket(
        process.env.VUE_APP_WS_URL + ":9991/api/v1/overview/ADMIN_VIEW/ws"
      );

      this.socket.onopen = () => {
        this.status = "connected";
        console.log(this.status);
        let currentFilter = [
          this.selects.selectCustomer,
          this.selects.selectRegion,
          this.selects.selectRoute,
        ];
        this.socket.send(currentFilter);
        this.isLoading = true;
        // this.socket.send(["Customer-1", "Region-1", "Route-2"]);
      };

      this.socket.onmessage = ({ data }) => {
        console.log(this.selects.selectCustomer);
        this.parseData(data);
      };

      return this.socket;
    },
    parseData(data) {
      console.log("CALLED PARSE");
      console.log("CALLED PARSE");
      let totalCollect = 0;
      let collected = 0;
      let notCollected = 0;
      this.collectionGraph.loaded = false;
      this.statusRatio.loaded = false;

      let rawpayload = JSON.parse(data);

      console.log(rawpayload);
      this.bounds = [];
      this.custData = rawpayload.custData;
      this.mapData = rawpayload.mapData;
      this.ratingData = rawpayload.ratingData;
      this.graphData = rawpayload.graphData;
      this.totalPickup = rawpayload.totalPickup;
      if (rawpayload.namespace == "ADMIN_VIEW") {
        // ###################################################################################################### //

        // STORE INITIAL CUSTOMER SELECT
        if (this.selects.selectCustomer == "*") {
          this.selects.customers = [{ value: "*", label: "All" }];

          for (let i = 0; i < this.mapData.length; i++) {
            this.selects.customers.push({
              value: this.mapData[i].custid,
              label: this.mapData[i].custname,
            });
          }
          this.selects.customers = [
            ...new Set(
              this.selects.customers.map((itm) => JSON.stringify(itm))
            ),
          ].map((i) => JSON.parse(i));
        }

        // STORE REGION SELECT
        if (this.selects.selectCustomer != "*") {
          console.log("yeaay");
          this.disableRegion = false;
          this.selects.regions = [{ value: "*", label: "All" }];

          for (let i = 0; i < this.mapData.length; i++) {
            this.selects.regions.push({
              value: this.mapData[i].regionid,
              label: this.mapData[i].regionname,
            });
          }
          this.selects.regions = [
            ...new Set(this.selects.regions.map((itm) => JSON.stringify(itm))),
          ].map((i) => JSON.parse(i));
        }

        // STORE ROUTE SELECT
        if (
          this.selects.selectCustomer != "*" &&
          this.selects.selectRegion != "*" &&
          this.selects.selectRoute == "*"
        ) {
          this.disableRoute = false;
          this.selects.routes = [{ value: "*", label: "All" }];

          for (let i = 0; i < this.mapData.length; i++) {
            this.selects.routes.push({
              value: this.mapData[i].routeid,
              label: this.mapData[i].routename,
            });
          }
          this.selects.routes = [
            ...new Set(this.selects.routes.map((itm) => JSON.stringify(itm))),
          ].map((i) => JSON.parse(i));
        }
        // ###################################################################################################### //

        // Marshalling for Overall Collection Graph
        let totalCollectGraph = 0;
        let collectedGraph = [];
        let notCollectedGraph = [];
        let totalCollectedGraph = 0;
        let length = moment().format("H");

        for (let i = 0; i < rawpayload.totalPickup.length; i++) {
          totalCollectGraph += rawpayload.totalPickup[i].totalpickup;
        }
        let totalGraph = Array(24).fill(totalCollectGraph);
        let tempCollect;
        console.log(length);
        if (this.graphData.length < length) {
          tempCollect = Array(parseInt(length) + 1).fill(0);

          for (let j = 0; j < this.graphData.length; j++) {
            let time = moment(this.graphData[j].timestamp).format("H");
            tempCollect[time] = this.graphData[j].collect;
          }

          for (let i = 0; i < tempCollect.length; i++) {
            totalCollectedGraph += tempCollect[i];
            collectedGraph.push(totalCollectedGraph);
            console.log(totalCollectGraph);

            totalCollectGraph = totalCollectGraph - tempCollect[i];

            if (totalCollectGraph < 0) {
              totalCollectGraph = 0;
            }
            notCollectedGraph.push(totalCollectGraph);
          }
        } else {
          for (let i = 0; i < this.graphData.length; i++) {
            totalCollectedGraph += this.graphData[i].collect;
            collectedGraph.push(totalCollectedGraph);
            totalCollectGraph = totalCollectGraph - this.graphData[i].collect;
            if (totalCollectGraph < 0) {
              totalCollectGraph = 0;
            }
            notCollectedGraph.push(totalCollectGraph);
          }
        }

        console.log("UPDATE!");
        this.updateCollectionGraph(
          totalGraph,
          collectedGraph,
          notCollectedGraph,
          this.graphLabel
        );

        // ###################################################################################################### //

        //CARD DATA
        for (let i = 0; i < rawpayload.custData.length; i++) {
          totalCollect += parseInt(rawpayload.custData[i].ttlcollect);
          collected += parseInt(rawpayload.custData[i].collect);
          notCollected = totalCollect - collected;
        }
        let totalDriver = 0;

        this.driverData = [];
        let arrayLat = [];
        let arrayLong = [];
        let cntrbound = [];
        for (let i = 0; i < this.mapData.length; i++) {
          if (this.mapData[i].DriverName != null) {
            let uniqueDriver = [...new Set(this.mapData[i].DriverName)];
            totalDriver += uniqueDriver.length;
          }

          let time = this.mapData[i].CreatedAt[0];
          let lastPickup = time == "0" ? "-" : moment(time).format("LT");

          let pickupStat;
          this.mapData[i].status == 1
            ? (pickupStat = require("@/assets/img/icon_on.png"))
            : (pickupStat = require("@/assets/img/icon_off.png"));

          let data = {
            id: i,
            pointName: this.mapData[i].pickupname,
            lastPickup: lastPickup,
            routeName: this.mapData[i].routename,
            driverName:
              this.mapData[i].DriverName == null
                ? "-"
                : this.mapData[i].DriverName[0],
            picture: "https://image.flaticon.com/icons/png/512/40/40165.png",
            modal: false,
            real: `https://afes.vectolabs.com:9991/images/${this.mapData[i].ColImgPath[0]}`,
            status: pickupStat,
          };
          this.driverData.push(data);

          // if (~~parseFloat(this.mapData[i].lat) == 0) {
          if (this.mapData[i].lat == "0") {
            // this.bounds.push([0, 0]);
            // arrayLat.push(0);
            // arrayLong.push(0);
          } else {
            this.bounds.push([
              parseFloat(this.mapData[i].lat),
              parseFloat(this.mapData[i].long),
            ]);
            // arrayLat.push(parseFloat(this.mapData[i].lat));
            // arrayLong.push(parseFloat(this.mapData[i].long));
          }
        }
        // this.bounds.push(latLngBounds(cntrbound))
        console.log(this.mapData);
        console.log(this.bounds);
        // console.log(arrayLat.reduce((a, b) => a + b, 0) / arrayLat.length);
        // let avgLat = arrayLat.reduce((a, b) => a + b, 0) / arrayLat.length;
        // let avgLong = arrayLong.reduce((a, b) => a + b, 0) / arrayLong.length;
        // console.log(avgLat);
        // console.log(avgLong);

        // this.center = L.latLng(
        //   parseFloat(avgLat.toFixed(6)),
        //   parseFloat(avgLong.toFixed(6))
        // );

        this.statsCards_2[0].title = totalCollect.toString();
        this.statsCards_2[1].title = collected.toString();
        this.statsCards_2[2].title = notCollected.toString();
        if (rawpayload.activeDriver == undefined) {
          this.statsCards_2[3].title = "0";
        } else {
          this.statsCards_2[3].title = rawpayload.activeDriver.toString();
        }

        // PERCENTAGE DATA
        this.cPercentage = parseFloat(
          ((collected / totalCollect) * 100).toFixed(2)
        );
        this.ncPercentage = parseFloat(
          ((notCollected / totalCollect) * 100).toFixed(2)
        );

        //UPDATE PIE CHART STATUS RATIO
        this.updateChart(totalCollect, notCollected, collected);

        // ###################################################################################################### //

        //CUSTOMER LIST
        this.tableData = [];

        for (let i = 0; i < rawpayload.overallList.length; i++) {
          let row = {
            custname: rawpayload.overallList[i].custname,
            totalpickup: rawpayload.overallList[i].totalcollected,
            collected: rawpayload.overallList[i].collected,
            notcollected:
              rawpayload.overallList[i].totalcollected -
              rawpayload.overallList[i].collected,
          };

          this.tableData.push(row);
        }

        //CUSTOMER_RATING
        let s1 = 0;
        let s2 = 0;
        let s3 = 0;
        let s4 = 0;
        let s5 = 0;

        for (let i = 0; i < rawpayload.ratingData.length; i++) {
          s1 += rawpayload.ratingData[i].star1;
          s2 += rawpayload.ratingData[i].star2;
          s3 += rawpayload.ratingData[i].star3;
          s4 += rawpayload.ratingData[i].star4;
          s5 += rawpayload.ratingData[i].star5;
          // this.tableData.push(load);
        }
        this.customerRating.chartData.datasets[0].data = [s1, s2, s3, s4, s5];
        this.customerRating.loaded = true;
        console.log(this.customerRating.chartData.datasets);
        this.isLoading = false;
      }
    },

    async updateCollectionGraph(total, collected, notCollected, label) {
      this.collectionGraph = await {
        chartData: {
          labels: label,
          datasets: [
            {
              label: "Collected",
              fill: true,
              borderColor: "rgba(50, 130, 184, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(50, 130, 184, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: collected,
            },
            {
              label: "Not Collected",
              fill: true,
              borderColor: "rgba(255, 3, 2, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 3, 2, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: notCollected,
            },
            {
              label: "Total Collection",
              fill: true,
              borderColor: "rgba(255, 255, 255, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 255, 255, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: total,
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(50, 130, 184, 0.5)",
          "rgba(50, 130, 184, 0.0)",
          "rgba(50, 130, 184, 0.0)",
          "rgba(255, 3, 2, 0.5)",
          "rgba(255, 3, 2, 0)",
          "rgba(255, 3, 2, 0)",
          "rgba(255, 255, 255, 0.5)",
          "rgba(255, 255, 255, 0.0)",
          "rgba(255, 255, 255, 0.0)",
        ],
        gradientStops: [1, 0.4, 0, 1, 0.4, 0, 1, 0.4, 0],
      };

      this.collectionGraph.loaded = true;
    },
    async updateChart(total, notCollected, collected) {
      //PIECHART
      // let pie = await {
      //   pointRadius: 0,
      //   pointHoverRadius: 0,
      //   backgroundColor: ["#ffffff", "#ff0302", "#3282b8"],
      //   borderWidth: 0,
      //   data: [parseInt(a[0][0]), parseInt(a[0][2]), parseInt(a[0][1])]
      // };

      this.statusRatio = await {
        chartData: {
          labels: ["Total Pickup", "Not Collected", "Collected"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#ffffff", "#ff0302", "#3282b8"],
              borderWidth: 0,
              data: [total, notCollected, collected],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.pieChartOptions,
      };
      // this.statusRatio.chartData.datasets.push(pie);
      this.statusRatio.loaded = true;
    },
    markerIcon(deviceStatus) {
      if (deviceStatus == 1) {
        return L.icon({
          iconUrl: require("@/assets/img/icon_on.png"),
          // shadowUrl: require("@/assets/img/marker-shadow.png"),

          iconSize: [10, 10], // size of the icon
          iconAnchor: [3, 7], // point of the icon which will correspond to marker's location
          shadowAnchor: [2, 16], // the same for the shadow
          shadowSize: [22, 25],
          popupAnchor: [-3, -76],
        });
      } else {
        return L.icon({
          iconUrl: require("@/assets/img/icon_off.png"),
          // shadowUrl: require("@/assets/img/marker-shadow.png"),

          iconSize: [10, 10], // size of the icon
          iconAnchor: [3, 7], // point of the icon which will correspond to marker's location
          shadowAnchor: [2, 16], // the same for the shadow
          shadowSize: [22, 25],
          popupAnchor: [-3, -76],
        });
      }
    },
    switchView() {
      return this.switches.defaultOn ? "List View" : "Map View";
    },
    addMarker(event) {
      console.log(event.latlng);
      console.log("test1", this.$refs.markersRef);
      let obj = {
        location: event.latlng,
        pointName:
          "<h4 class='text-center'>Point A</h4> <img src='https://image.flaticon.com/icons/png/512/40/40165.png'> <br/><br/> Last pickup: 10:00 AM",
        status: 1,
      };
      this.markers.push(obj);
    },
    //  changeSize(evt) {
    //   console.log(evt);
    //   console.log(this.$refs.markersRef[0]._props);

    //   // this.$refs.markersRef[0]._props.icon.iconSize =  [40, 40];
    //   return L.icon({
    //       iconUrl: require("@/assets/img/icon_off.png"),
    //       iconSize: [17, 17], // size of the icon
    //     });
    // },
  },
};
</script>
<style lang="scss" scoped>
.tab {
  margin-left: 1%;
  margin-right: 1%;
}
.card-stats {
  margin-bottom: 3%;
  height: 120px;
}
th > .cell {
  font-size: 100%;
}
.list-color > ul > li {
  color: #003975;
}
input[type="image"] {
  display: block;
  border: none;
  outline: none;
}
.bottom {
  margin-bottom: 0px;
}
.select-width {
  max-width: 50%;
}
.spinner {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
